import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';



class  SnackBar extends React.Component{
  render(){
    return (       

      <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      classes = {{
        "root": "top-snackbar"
      }}
      autoHideDuration={2000}
      open={this.props.open}
      onClose={() => {this.props.handleSnackbarClose()}}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={<span id="message-id">{this.props.message}</span>}
      />  

        );
      }
      
}

export default withStyles({
  root: {
    top: "8px"
  }
})(SnackBar)


// import React from 'react';
// import Snackbar from '@mui/material/Snackbar';
// import { withStyles } from '@mui/styles';


// const StyledSnackbar = withStyles(Snackbar)({
//   top: "8px"
// });

// class SnackBar extends React.Component {
//   render() {
//     return (       
//       <StyledSnackbar
//         anchorOrigin={{
//           vertical: 'top',
//           horizontal: 'center',
//         }}
//         autoHideDuration={2000}
//         open={this.props.open}
//         onClose={this.props.handleSnackbarClose}
//         message={<span id="message-id">{this.props.message}</span>}
//       />  
//     );
//   }
// }

// export default SnackBar;
